import { memo } from 'react';

import { ChevronDownIcon, DownloadIcon } from '@air/design-icons';
import { Button } from '@air/primitive-button';
import { ButtonGroup } from '@air/primitive-button-group';
import { DropdownMenu, type DropdownMenuOption, renderDropdownItems } from '@air/primitive-dropdown-menu';
import { IconButton } from '@air/primitive-icon-button';

export type DownloadButtonsProps = {
  isIconOnly?: boolean;
  onDownload?: () => void;
  options: DropdownMenuOption[];
};

export const DownloadButtons = memo(({ isIconOnly = false, onDownload, options }: DownloadButtonsProps) => {
  if (isIconOnly) {
    return (
      <ButtonGroup data-testid="ASSET_MODAL_DOWNLOAD_BUTTONS">
        {options.length > 0 ? (
          <DropdownMenu
            align="end"
            className="w-[280px]"
            trigger={
              <IconButton
                adsIcon
                aria-label="Download"
                appearance="filled"
                color="gray"
                data-testid="ASSET_MODAL_DOWNLOAD_BUTTONS_DOWNLOAD_BUTTON"
                icon={DownloadIcon}
                label="Download"
                size="medium"
              />
            }
          >
            {renderDropdownItems({ options })}
          </DropdownMenu>
        ) : (
          <IconButton
            adsIcon
            aria-label="Download"
            appearance="filled"
            color="gray"
            data-testid="ASSET_MODAL_DOWNLOAD_BUTTONS_DOWNLOAD_BUTTON"
            icon={DownloadIcon}
            label="Download"
            onClick={onDownload}
            size="medium"
          />
        )}
      </ButtonGroup>
    );
  }

  return (
    <ButtonGroup data-testid="ASSET_MODAL_DOWNLOAD_BUTTONS">
      <Button
        appearance="filled"
        color="gray"
        data-testid="ASSET_MODAL_DOWNLOAD_BUTTONS_DOWNLOAD_BUTTON"
        onClick={onDownload}
        prefix={<DownloadIcon size="sm" />}
        size="medium"
      >
        Download
      </Button>
      {options.length > 0 && (
        <DropdownMenu
          align="end"
          className="w-[280px]"
          trigger={
            <IconButton
              adsIcon
              appearance="filled"
              color="gray"
              data-testid="ASSET_MODAL_DOWNLOAD_BUTTONS_DROPDOWN_BUTTON"
              icon={ChevronDownIcon}
              label="Download"
              size="medium"
            />
          }
        >
          {renderDropdownItems({ options })}
        </DropdownMenu>
      )}
    </ButtonGroup>
  );
});

DownloadButtons.displayName = 'DownloadButtons';
